<script>
  import { handleTextContent } from '../utils'
  const CHAR_LIMIT = 300

  export let component
  export let text
  export let fontSize
  export let readMoreText
  export let readLessText
  export let readMoreTextColor
  let cursorStyle
  let isToggle = true

  let message = handleTextContent(
    text,
    CHAR_LIMIT,
    readMoreTextColor,
    readMoreText
  )

  const textExceedsCharLimit = text && text.length > CHAR_LIMIT

  $: cursorStyle = textExceedsCharLimit
    ? 'cursor: pointer;'
    : 'pointer-events: none;'

  const toggleContent = () => {
    if (textExceedsCharLimit && isToggle) {
      message = `${text}</br><b style ='color: ${readMoreTextColor};'>${readLessText}<b>`
      isToggle = !isToggle
    } else {
      message = handleTextContent(
        text,
        CHAR_LIMIT,
        readMoreTextColor,
        readMoreText
      )
      isToggle = !isToggle
    }
  }
</script>

<svelte:component
  this={component}
  onClick={toggleContent}
  {message}
  style={`${cursorStyle} font-size:${fontSize}px;`} />
